"use strict";

exports.__esModule = true;
var _SectionLabelElement = require("./SectionLabelElement");
Object.keys(_SectionLabelElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SectionLabelElement[key]) return;
  exports[key] = _SectionLabelElement[key];
});
var _SectionLabelThumbnail = require("./SectionLabelThumbnail");
Object.keys(_SectionLabelThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SectionLabelThumbnail[key]) return;
  exports[key] = _SectionLabelThumbnail[key];
});
var _SectionLabelFields = require("./SectionLabelFields");
Object.keys(_SectionLabelFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SectionLabelFields[key]) return;
  exports[key] = _SectionLabelFields[key];
});
var _SectionLabelHeader = require("./SectionLabelHeader");
Object.keys(_SectionLabelHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SectionLabelHeader[key]) return;
  exports[key] = _SectionLabelHeader[key];
});
var _widget = require("./widget");
Object.keys(_widget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _widget[key]) return;
  exports[key] = _widget[key];
});